var POSTED_DATE = 'Fecha de Registro';
var es = {
    activity: {
        noTransactionsMessage: 'No tiene ninguna actividad en los últimos 6 meses',
        noTransactionsMessageWithMonths: 'No tiene ninguna actividad para revisar',
        byDateFilterOption: 'Filtrar por Fecha',
        allTransactionsFilterOption: 'Todas las Transacciones Disponibles',
        recentTransactionsFilterOption: 'Actividad Desde el Último Estado de Cuenta',
        statementEndingFilterOption: 'Estado de Cuenta que Termina en - {{date}}',
        loadMoreButton: 'Cargar Más',
        dateTableHeader: 'Fecha',
        descriptionTableHeader: 'Descripción',
        manageDisputesButton: 'Administrar Disputas',
        disputeTransactionButton: 'TODO',
        typeTableHeader: 'Tipo',
        statusTableHeader: 'Estado',
        amountTableHeader: 'Monto',
        transactionTypeAdjustment: 'Ajuste',
        transactionTypeAuthorization: 'Autorización',
        transactionTypeCashAdvance: 'Adelanto en efectivo',
        transactionTypeCredit: 'Crédito',
        transactionTypeDefault: 'Transacción',
        transactionTypeFee: 'Cobro',
        transactionTypeInterest: 'Interés',
        transactionTypeLateFee: 'Tarifa por mora',
        transactionTypePayment: 'Pago',
        transactionTypePurchase: 'Compra',
        transactionTypeRefund: 'Reembolso'
    },
    activityDetails: {
        activityDetailHeader: 'Detalle de Actividad',
        amountLabel: 'Monto',
        addressLabel: 'Dirección',
        canceledLabel: 'Cancelado',
        chargedOnDateLabel: 'Fecha de Cobro',
        confirmationNumberLabel: 'Número de Confirmación',
        detailsLabel: 'Detalles',
        purchaseLocationLabel: 'Ubicación de compra',
        phoneLabel: 'Teléfono',
        postedDateLabel: POSTED_DATE,
        refNumberLabel: 'Número de Referencia',
        recurringChargeLabel: 'Cargo Recurrente',
        recurringChargeLabelValue: 'Este puede ser un cargo recurrente',
        cancelPayment: {
            cancelPaymentButton: 'Cancelar el Pago',
            cancelPaymentHeading: 'Cancelar el Pago',
            paymentCanceledHeading: 'Pago Cancelado',
            confirmCancelPaymentButton: 'Sí, Cancelar el Pago',
            closeCancelPaymentButton: 'No, Cerrar',
            scheduledForLabel: 'Programado para',
            canceledConfirmHeader: '¿Está seguro de que desea cancelar este pago?',
            canceledCompleteHeader: 'Se ha cancelado su pago',
            canceledErrorHeader: 'Lo sentimos, algo salió mal',
            canceledErrorMessage: 'Hubo un problema al cancelar su pago.\n Cierre esta página y vuelva a intentarlo más tarde.'
        }
    },
    common: {
        apiErrorHeading: 'Oops...',
        apiErrorMessage: 'Lamentablemente no podemos procesar su solicitud en este momento.\n Por favor, intente nuevamente más tarde.',
        apiDataMissingHeading: 'Tenemos problemas para recuperar esta información',
        apiDataMissingMessage: 'Por favor, intente nuevamente más tarde.',
        backButton: 'Regresar',
        canceledStatus: 'Cancelado',
        closeButton: 'Cerrar',
        defaultAccountLabel: 'Su Cuenta de Synchrony',
        endingInSubHeading: 'Cuenta que termina en',
        pendingStatus: 'Pendiente',
        postedStatus: 'Registrado',
        processingStatus: 'Procesando',
        rejectedStatus: 'Rechazado',
        scheduledStatus: 'Programado',
        viewAllActivityButton: 'Ver Toda la Actividad'
    },
    navBar: {
        activityButton: 'Actividad',
        promotionsButton: 'Promociones'
    },
    selectPay: {
        availabilityLabel: 'Disponible Ahora',
        bannerButton: 'Explore Más.',
        bannerSubHeading: 'Obtenga más control en la administración de sus gastos con una APR reducida y pagos mensuales iguales predecibles.',
        fullSizeBannerSubheading: 'Obtenga más control en la administración de sus gastos con',
        brandHeading: 'Synchrony Select Pay',
        detailsAccordionButton: 'Mire cómo funciona',
        completeDetailsHeading: 'Detalles de Synchrony Select Pay',
        completeFooterText: 'Por favor espere hasta 2 días para que esto se refleje en su cuenta. Esto no cambiará la fecha de vencimiento de su pago.',
        completeMonthlyPaymentAmountLabel: 'Monto Mensual de Pago',
        completeMonthlyPaymentsLabel: 'Número de Pagos Mensuales',
        completePurchaseDetailsLabel: 'Detalles de la Compra',
        completeHeading: 'Inscripción exitosa en Synchrony Select Pay',
        completeTotalPurchaseAmountLabel: 'Monto Total de Compra',
        completeSubHeading: 'Se ha enviado un correo electrónico de confirmación a la dirección de correo electrónico registrada.',
        completeTransactionHeading: 'Transacciones Incluidas',
        annualPercentageRateLabel: 'APR de la promoción',
        estimatedInterestAmountLabel: 'Interés Total',
        estimatedTotalAmountLabel: 'Monto Total',
        errorPromoLimitReachedHeading: 'Ha alcanzado su límite de Synchrony Select Pay',
        errorPromoLimitReachedSubHeading: 'Liquide uno de sus saldos promocionales para agregar una nueva transacción.',
        installmentsSelectOptionsHeading: 'Seleccione la oferta de Synchrony Select Pay que funcione mejor para usted',
        installmentsReviewHeading: 'Por favor revise la oferta Synchrony Select Pay seleccionada',
        installmentsReviewDisclaimerText: 'Una vez aceptada, esta oferta es final y no se puede cambiar.',
        installmentsSelectedRowHeading: 'Transacción seleccionada para Synchrony Select Pay',
        installmentRateLabel: 'APR (Tasa de Porcentaje Anual)',
        installmentMonthLabel: 'Mes',
        installmentsMonthsLabel: 'meses',
        promotionalTermDetailsHeading: 'Detalles de Términos Promocionales',
        promotionalTermDetailsSubheading: 'Al elegir Aceptar la Oferta a continuación, usted comprende y acepta que:​',
        termDetailsBullet1Text: 'Todo Interés Total y Montos Totales que se muestran son solo estimados.',
        termDetailsBullet2Text: 'Se cobrará una APR reducida en esta transacción a partir de (1) la fecha de la transacción mostrada o (2) el primer día del ciclo de facturación en el que elija esta oferta promocional, y se requieren pagos mensuales fijos hasta que la transacción se pague en su totalidad. Estos pagos son iguales a {{percentageValue}}% del monto de la transacción mostrado, redondeado al siguiente centavo entero y pueden ser mayores que los pagos que se requerirían si esta transacción no se incluyera en esta promoción. Durante el/los último(s) mes(es) del período promocional, el pago mensual requerido podría reducirse debido al redondeo en los meses anteriores.',
        termDetailsBullet3Text: 'Los pagos mensuales requeridos que se muestren calculados en conexión con esta oferta promocional deberían permitirle cancelar la transacción dentro del período promocional si (1) hace los pagos antes de la fecha de vencimiento cada mes y (2) este es el único saldo de la cuenta durante el período promocional. Si hay otros saldos en su cuenta, incluso otros saldos promocionales, este pago mensual se sumará al pago mínimo correspondiente a esos saldos.',
        termDetailsBullet4Text: 'Se seguirán aplicando los términos regulares de la cuenta a las transacciones no promocionales de su cuenta. Consulte los términos del acuerdo de su tarjeta de crédito.',
        termDetailsBullet5Text: 'Si una compra (o cualquier parte de la compra) que esté sujeta a esta promoción se devuelve, por favor, llame al número que figura en su estado de facturación o al dorso de su tarjeta para solicitar que el crédito se aplique a este saldo promocional.',
        primaryDefaultButton: 'Continuar',
        primaryInstallmentsButton: 'Continuar',
        primaryReviewButton: 'Aceptar la oferta',
        secondaryInstallmentsButton: 'Cambiar selección',
        secondaryReviewButton: 'Cambiar selección',
        secondaryDefaultButton: 'Cambiar transacción',
        selectTransactionHeading: 'Seleccione una transacción a continuación',
        selectTransactionSubHeading: 'Solo se permiten 4 saldos de Synchrony Select Pay por cuenta a la vez y las transacciones en disputa no son elegibles.',
        selectTransactionBullet1Text: 'Seleccione qué transacción elegible desea saldar con una APR reducida.',
        selectTransactionBullet2Text: 'Elija la APR reducida y el número de pagos mensuales en la siguiente pantalla.',
        selectTransactionBullet3Text: 'Revise sus selecciones y acepte los términos de la oferta. El monto de su pago mensual de Synchrony Select Pay se agregará a su pago mínimo adeudado.',
        transactionDisputesErrorHeading: 'La transacción que seleccionó no es elegible para Synchrony Select Pay',
        transactionDisputesErrorSubHeading: 'La transacción que seleccionó se encuentra actualmente en disputa y no es elegible para Synchrony Select Pay. Si tiene alguna pregunta, por favor llame al número que se encuentra en el dorso de la tarjeta.'
    },
    spendingTrends: {
        categoryLabel: {
            restaurants: 'Restaurantes',
            grocery: 'Supermercado',
            'health&beauty': 'Salud y Belleza',
            airlines: 'Aerolíneas',
            lodging: '	Alojamiento',
            gas: 'Combustible',
            'bills&utilities': 'Facturas y Servicios Públicos',
            entertainment: 'Entretenimiento',
            transportation: 'Transporte',
            contractedservices: 'Servicios Contratados',
            other: 'Otro'
        },
        bannerText: 'Vea sus tendencias de gastos',
        drawerHeading: 'Tendencias de Gastos',
        chartHeading: 'Mis Tendencias de Gastos',
        chartSubHeading: 'Aquí tiene una imagen de sus gastos',
        chartDetailTotalLabel: 'Total',
        chartDetailSpentLabel: 'Gastado',
        chartDetailOverallSpendLabel: 'del gasto total',
        chartEmptyLabel: 'No hay compras para mostrar',
        totalSpentLabel: 'Total Gastado',
        primaryButton: 'Regresar a la Actividad',
        categoriesTableHeader: 'Categorías',
        percentSpentTableHeader: 'Porcentaje Gastado',
        amountTableHeader: 'Monto Gastado',
        categoriesNotShownNoticeText: 'No se muestran las categorías con $0 gastados.',
        disclaimerBoldedText: 'Nota:',
        disclaimerText: 'Las tendencias de gastos por categoría reflejan compras registradas. Si obtiene recompensas por categoría, esas categorías de recompensas pueden diferir de las exhibidas en la tabla de arriba. Consulte información específica en los términos de recompensas de la tarjeta de crédito.'
    }
};
export default es;
//# sourceMappingURL=es.js.map